<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_7698_265)">
      <rect x="0.75" y="2.75" width="14.5" height="12.5" rx="2.25" stroke="#727272" stroke-width="1.5"/>
      <path d="M10.75 1V4" stroke="#727272" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M4.75 1V4" stroke="#727272" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M1 6.5L15 6.5" stroke="#727272" stroke-width="1.5" stroke-linecap="round"/>
    </g>
    <defs>
      <clipPath id="clip0_7698_265">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconCalendar'
}
</script>
